<template>
  <v-layout>
    <v-dialog v-model="showDialogItem" persistent max-width="600">
      <v-card>
        <v-toolbar color="white" class="elevation-1">
          <v-toolbar-title class="black--text font-weight-light">{{titleComponent}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn :disabled="loading" flat color="error" icon round @click.native="cancelNewItem()">
              <v-icon large color="error">clear</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>

          <v-layout justify-space-between row wrap>
            <v-flex xs12 py-0>
              <v-autocomplete :items="uniformsAndEPIs" box item-value="description" item-text="description" v-model="uniformAndEPI"
                label="Descrição / Especificação" return-object></v-autocomplete>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field box v-model="uniformAndEPI.unity" label="Unidade" title="Unidade" disabled></v-text-field>
            </v-flex>
            <v-flex xs12 py-0>
              <v-text-field v-model="uniformAndEPI.quantity" label="Quantidade" box></v-text-field>
            </v-flex>
            <!--   <v-flex xs12 py-0>
              <v-text-field box v-model="uniformAndEPI.lifetime" :label="labelDepreciation"></v-text-field>
            </v-flex> -->
            <v-flex xs12 py-0>
              <v-text-field v-model.lazy="uniformAndEPI.value" label="Valor Unitário (R$)" box></v-text-field>
            </v-flex>
          </v-layout>

        </v-card-text>
        <v-card-actions class="pb-3">
          <v-btn :disabled="loading" :loading="loading" block round color="success lighten-1" @click.native="save();">
            Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
  import ProductService from "../../../service/ProductService.js";
  export default {

    data() {
      return {
        loading: false,
        showDialogItem: false,
        edit:false,
        uniformAndEPI: {},
        uniformsAndEPIs: []
      }
    },

    methods: {
      addNewItem() {
        this.initialize()
        this.showDialogItem = true
      },
      cancelNewItem() {
        this.uniformAndEPI = {};
        this.uniformsAndEPIs = [];
        this.showDialogItem = false;
      },
      editItem(item) {
        this.uniformAndEPI = item;
        this.edit = true;
        this.showDialogItem = true
      },
      save() {
        this.$emit('addUniformAndEPI', this.uniformAndEPI)
        this.showDialogItem = false;
      },
      async loadDescription(){
        this.uniformsAndEPIs = await ProductService.getByCategory({
          type: "Uniforme e EPI's"
        });
      },
      async initialize() {
        this.loading = true;
        try {
          await this.loadDescription()
          this.edit = false
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false
        }
      },
    },
     computed:{
      titleComponent(){
        return this.edit ? "Editar Item" : "Novo Item"
      }
    }
  }

</script>
S



// WEBPACK FOOTER //
// src/components/contract/dialogs/DialogUniformAndEPIs.vue